// src/services/CustomerService.js
import axios from "axios";

const REST_API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/customer`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

export const listCustomer = () =>
  axios.get(REST_API_BASE_URL, {
    headers: authHeaders(),
  });

export const createCustomer = (customer) =>
  axios.post(REST_API_BASE_URL, customer, {
    headers: authHeaders(),
  });

export const updateCustomer = (customerId, customer) =>
  axios.put(`${REST_API_BASE_URL}/${customerId}`, customer, {
    headers: authHeaders(),
  });

export const getCustomer = (customerId) =>
  axios.get(`${REST_API_BASE_URL}/${customerId}`, {
    headers: authHeaders(),
  });

export const deleteCustomer = (customerId) =>
  axios.delete(`${REST_API_BASE_URL}/${customerId}`, {
    headers: authHeaders(),
  });

export const deleteAllCustomers = () =>
  axios.delete(`${REST_API_BASE_URL}/deleteAll`, {
    headers: authHeaders(),
  });

/**
 * Fetch total customers for the dashboard KPI.
 * Response shape: { totalCustomers: number }
 */
export const getTotalCustomers = () =>
  axios.get(`${REST_API_BASE_URL}/count`, {
    headers: authHeaders(),
  });

/**
 * Fetch owing customers (default cutoff = 30 days).
 * Backend endpoint: GET /api/customer/owing?days={days}
 * Returns List<OwingCustomerDTO>
 */
export const getOwingCustomers = (days = 30) =>
  axios.get(`${REST_API_BASE_URL}/owing?days=${encodeURIComponent(days)}`, {
    headers: authHeaders(),
  });
